// Active Ingredients Popup Mobile - JavaScript
(function() {
  const aipopCarousel = document.querySelector('.aipop-carousel');
  const cardCounter = document.querySelector('.aipop-card-counter');

  let aipopStartX = 0;
  let aipopCurrentIndex = 0;

  // Arrow Buttons
  const prevButton = document.querySelector('.aipop-prev-button');
  const nextButton = document.querySelector('.aipop-next-button');
  const totalCards = document.querySelectorAll('.aipop-card').length;

  // Left Arrow - Go to Previous Card
  prevButton.addEventListener('click', () => {
    if (aipopCurrentIndex > 0) {
      aipopCurrentIndex--;
      updateAipopCarousel();
    }
  });

  // Right Arrow - Go to Next Card
  nextButton.addEventListener('click', () => {
    if (aipopCurrentIndex < totalCards - 1) {
      aipopCurrentIndex++;
      updateAipopCarousel();
    }
  });

  function updateArrowVisibility() {
    prevButton.style.display = 'flex';
    nextButton.style.display = 'flex';
  }

  // Update Arrows and Carousel Position
  function updateAipopCarousel() {
    aipopCarousel.style.transform = `translateX(-${aipopCurrentIndex * 340}px)`;
    cardCounter.textContent = `${aipopCurrentIndex + 1} OF ${totalCards}`;
    updateArrowVisibility();
    updateActiveCard();
  }

  function updateActiveCard() {
    const cards = document.querySelectorAll('.aipop-card');
    cards.forEach((card, index) => {
      if (index === aipopCurrentIndex) {
        card.classList.add('aipop-card-active');
      } else {
        card.classList.remove('aipop-card-active');
      }
    });
  }

  // Initialize Arrows
  updateArrowVisibility();

  aipopCarousel.addEventListener('touchstart', (e) => {
    aipopStartX = e.touches[0].clientX;
  });

  aipopCarousel.addEventListener('touchend', (e) => {
    const aipopEndX = e.changedTouches[0].clientX;
    const aipopDeltaX = aipopStartX - aipopEndX;

    if (aipopDeltaX > 50 && aipopCurrentIndex < 2) {
      aipopCurrentIndex++;
    } else if (aipopDeltaX < -50 && aipopCurrentIndex > 0) {
      aipopCurrentIndex--;
    }
    updateAipopCarousel();
  });

  // DOM Content Loaded Handler
  document.addEventListener('DOMContentLoaded', () => {
    const closeButtons = document.querySelectorAll('.aipop-close-button');
    const readMoreButtons = document.querySelectorAll('.ain-ingredient-popup-button');
    const overlay = document.querySelector('.aipop-overlay');
    const popupContainer = document.querySelector('.aipop-carousel-container');
    const carousel = document.querySelector('.aipop-carousel');
    const cards = document.querySelectorAll('.aipop-card');
    const prevButton = document.querySelector('.aipop-prev-button');
    const nextButton = document.querySelector('.aipop-next-button');
    const cardCounter = document.querySelector('.aipop-card-counter');
    
    let aipopCurrentIndex = 0;
    const totalCards = cards.length;
  
    function updateAipopCarousel() {
      carousel.style.transform = `translateX(-${aipopCurrentIndex * 340}px)`;
      cardCounter.textContent = `${aipopCurrentIndex + 1} OF ${totalCards}`;
      
      cards.forEach((card, index) => {
        if (index === aipopCurrentIndex) {
          card.classList.add('aipop-card-active');
        } else {
          card.classList.remove('aipop-card-active');
        }
      });
      
      updateArrowVisibility();
    }
  
    function updateArrowVisibility() {
      prevButton.style.display = 'flex';
      nextButton.style.display = 'flex';
    }
  
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        overlay.style.display = 'none';
        popupContainer.style.display = 'none';
        document.body.classList.remove('no-scroll');
      });
    });
  
    readMoreButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        aipopCurrentIndex = index;
        updateAipopCarousel();
        overlay.style.display = 'block';
        popupContainer.style.display = 'block';
        document.body.classList.add('no-scroll');
      });
    });
  
    prevButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (aipopCurrentIndex > 0) {
        aipopCurrentIndex--;
        updateAipopCarousel();
      }
    });
  
    nextButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (aipopCurrentIndex < totalCards - 1) {
        aipopCurrentIndex++;
        updateAipopCarousel();
      }
    });
  
    overlay.addEventListener('click', () => {
      overlay.style.display = 'none';
      popupContainer.style.display = 'none';
      document.body.classList.remove('no-scroll');
    });
  
    let startX = 0;
  
    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });
  
    carousel.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const deltaX = startX - endX;
  
      if (deltaX > 50 && aipopCurrentIndex < totalCards - 1) {
        aipopCurrentIndex++;
      } else if (deltaX < -50 && aipopCurrentIndex > 0) {
        aipopCurrentIndex--;
      }
      updateAipopCarousel();
    });
  
    updateAipopCarousel();
  });
})();
